import { z } from 'zod';
import { DRIVER_STATUSES, VEHICLE_STATUSES, VEHICLE_TYPES } from '../constants.js';
import { emailSchema, idSchema, isoDateTime, pageQuerySchema, paginated } from './common.js';
/* -------------------------------- Driver -------------------------------- */
export const driverStatusSchema = z.enum(DRIVER_STATUSES);
export const driverSchema = z.object({
    id: idSchema,
    /** Link to a login user (the PWA account), when provisioned. */
    userId: idSchema.nullish(),
    name: z.string().min(1).max(120),
    email: emailSchema.nullish(),
    phone: z.string().max(40).nullish(),
    status: driverStatusSchema,
    licenseNumber: z.string().max(60).nullish(),
    licenseExpiry: isoDateTime.nullish(),
    notes: z.string().max(2000).nullish(),
    /** Derived: current vehicle load / active assignment count. */
    activeAssignments: z.number().int().min(0).optional(),
    createdAt: isoDateTime,
    updatedAt: isoDateTime,
});
export const driverCreateSchema = z.object({
    name: z.string().trim().min(1).max(120),
    email: emailSchema.nullish(),
    phone: z.string().trim().max(40).nullish(),
    status: driverStatusSchema.default('active'),
    licenseNumber: z.string().trim().max(60).nullish(),
    licenseExpiry: isoDateTime.nullish(),
    notes: z.string().max(2000).nullish(),
    /** Optional: create (or link) a DRIVER login for the PWA. */
    userId: idSchema.nullish(),
});
export const driverUpdateSchema = driverCreateSchema.partial().refine((v) => Object.keys(v).length > 0, { message: 'No fields to update' });
export const driverListSchema = paginated(driverSchema);
export const driverListQuerySchema = pageQuerySchema.extend({
    status: driverStatusSchema.optional(),
    search: z.string().max(200).optional(),
});
/* -------------------------------- Vehicle ------------------------------- */
export const vehicleStatusSchema = z.enum(VEHICLE_STATUSES);
export const vehicleSchema = z.object({
    id: idSchema,
    /** Registration plate (unique). */
    reg: z.string().trim().toUpperCase().min(2).max(12),
    name: z.string().min(1).max(120),
    makeModel: z.string().max(120).nullish(),
    vehicleType: z.enum(VEHICLE_TYPES),
    /** Payload capacity in kg — the gate for capacity checks. */
    payloadCapacityKg: z.number().finite().positive(),
    status: vehicleStatusSchema,
    motExpiry: isoDateTime.nullish(),
    insuranceExpiry: isoDateTime.nullish(),
    taxDue: isoDateTime.nullish(),
    notes: z.string().max(2000).nullish(),
    /** Derived: kg currently assigned across active jobs. */
    assignedKg: z.number().finite().min(0).optional(),
    utilisationPct: z.number().finite().min(0).optional(),
    createdAt: isoDateTime,
    updatedAt: isoDateTime,
});
export const vehicleCreateSchema = z.object({
    reg: z.string().trim().min(2).max(12),
    name: z.string().trim().min(1).max(120),
    makeModel: z.string().trim().max(120).nullish(),
    vehicleType: z.enum(VEHICLE_TYPES),
    payloadCapacityKg: z.number().finite().positive(),
    status: vehicleStatusSchema.default('active'),
    motExpiry: isoDateTime.nullish(),
    insuranceExpiry: isoDateTime.nullish(),
    taxDue: isoDateTime.nullish(),
    notes: z.string().max(2000).nullish(),
});
export const vehicleUpdateSchema = vehicleCreateSchema.partial().refine((v) => Object.keys(v).length > 0, { message: 'No fields to update' });
export const vehicleListSchema = paginated(vehicleSchema);
export const vehicleListQuerySchema = pageQuerySchema.extend({
    status: vehicleStatusSchema.optional(),
    vehicleType: z.enum(VEHICLE_TYPES).optional(),
    search: z.string().max(200).optional(),
});
//# sourceMappingURL=fleet.js.map